// Email
export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const emailPattern = {
  value: emailRegex,
  message: "Invalid email address"
};
export const emailRegisterOptions = {
  required: 'Email is required',
  pattern: emailPattern,
};

// Password
export const passwordRegex = /^[a-zA-Z0-9!"§$%&()=?*+#,.;:_-]{8,30}$/;
export const passwordPattern = {
  value: passwordRegex,
  message: 'Password can include uppercase, lowercase, numbers, and special characters as !"§$%&()=?*+#,.;:_-'
};
export const passwordRegisterOptions = {
  required: 'Password is required',
  minLength: { value: 8, message: 'Password must be at least 8 characters' },
  maxLength: { value: 30, message: 'Password must be at most 30 characters' },
  pattern: passwordPattern,
};
export const createConfirmPasswordRegisterOptions = (watch) => ({
  ...passwordRegisterOptions,
  validate: value => value === watch('password') || 'Passwords do not match',
});
